import { useState } from 'react';
import { Slider } from '../../components/Slider';
import { useEditorStore } from '../../store/editorStore';

type Range = 'shadows' | 'midtones' | 'highlights';

export function ColorGradingPanel() {
  const state = useEditorStore((s) => s.state);
  const update = useEditorStore((s) => s.update);
  const [range, setRange] = useState<Range>('midtones');

  const wheel = state.colorGrading[range];

  return (
    <>
      <div className="rowbtns">
        {(['shadows', 'midtones', 'highlights'] as Range[]).map((r) => (
          <button
            key={r}
            className={`chip ${range === r ? 'is-active' : ''}`}
            onClick={() => setRange(r)}
          >
            {r[0].toUpperCase() + r.slice(1)}
          </button>
        ))}
      </div>

      <div
        className="gradepreview"
        style={{
          background: `hsl(${wheel.hue}, ${wheel.sat}%, ${
            50 + wheel.lum / 4
          }%)`,
        }}
      />

      <Slider
        label="Hue"
        value={wheel.hue}
        min={0}
        max={360}
        onChange={(v) => update((d) => (d.colorGrading[range].hue = v))}
      />
      <Slider
        label="Saturation"
        value={wheel.sat}
        min={0}
        max={100}
        onChange={(v) => update((d) => (d.colorGrading[range].sat = v))}
      />
      <Slider
        label="Luminance"
        value={wheel.lum}
        min={-100}
        max={100}
        onChange={(v) => update((d) => (d.colorGrading[range].lum = v))}
      />

      <p className="hint">Global</p>
      <Slider
        label="Balance"
        value={state.colorGrading.balance}
        min={-100}
        max={100}
        onChange={(v) => update((d) => (d.colorGrading.balance = v))}
      />
      <Slider
        label="Blending"
        value={state.colorGrading.blending}
        min={0}
        max={100}
        defaultValue={50}
        onChange={(v) => update((d) => (d.colorGrading.blending = v))}
      />
    </>
  );
}
